import { SecurityFeature } from '@cast/types';

import { useSingleClusterSettingsQuery } from 'hooks/queries/security-insights';
import { isNotFoundError } from 'utils/api-utils';

import { useWasEnabled } from './useWasEnabled';
import { OnboardingPhase2HookProps } from '../types';

export const useWasNetworkMetricsEnabled = ({
  clusterId,
  onSuccess,
  onError,
  enabled,
}: OnboardingPhase2HookProps) => {
  const { settings, error } = useSingleClusterSettingsQuery({
    clusterId,
    refetchInterval: enabled ? 20_000 : false,
    enabled,
    // it's expected for the endpoint to return 404 while the cluster is onboarding
    retry: (_, error) => !isNotFoundError(error),
  });

  const isNetworkMetricsEnabled = Boolean(
    settings?.features?.includes(SecurityFeature.NETFLOW)
  );

  useWasEnabled({
    currentState: isNetworkMetricsEnabled,
    onSuccess: onSuccess,
    onError: onError,
    error: isNotFoundError(error) ? undefined : error,
    enabled,
  });

  return isNetworkMetricsEnabled;
};
